import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import L from "leaflet";
import { useMap } from "react-leaflet";

const ControlContainer = ({ position, children }) => {
    const map = useMap();
    const containerRef = useRef(document.createElement("div"));
    const controlRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        // Prevent click propagation to map
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        controlRef.current = L.control({ position: position || 'topright' });

        controlRef.current.onAdd = () => container;

        controlRef.current.addTo(map);

        return () => {
            if (controlRef.current) {
                controlRef.current.remove();
            }
        };
    }, [map, position]);

    // Add leaflet-control class to container if needed, or children should provide it.
    // Standard leaflet controls usually have 'leaflet-control leaflet-bar' if they are buttons.
    // For general containers, 'leaflet-control' is the base.

    useEffect(() => {
        containerRef.current.className = "leaflet-control";
    }, []);

    return ReactDOM.createPortal(children, containerRef.current);
};

export default ControlContainer;
